import { render } from "./saleconsumption.vue?vue&type=template&id=39ac0110&scoped=true"
import script from "./saleconsumption.vue?vue&type=script&lang=js"
export * from "./saleconsumption.vue?vue&type=script&lang=js"

import "./saleconsumption.vue?vue&type=style&index=0&id=39ac0110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ac0110"]])

export default __exports__